import SealCard from './SealCard'
import SealCardItem from './SealCardItem'
import SealCardImage from './SealCardImage'

SealCard.Item = SealCardItem
SealCard.Image = SealCardImage

export default SealCard
